// extracted by mini-css-extract-plugin
export default {"flashModal":"iqx1fi276ggvU1I9SIIP"};